
import * as Yup from "yup";

/** Message */
export const messageRules = Yup.string()
  .min(20, "validator:rules.ContactRules.MessageRules.min")
  .max(4000, "validator:rules.ContactRules.MessageRules.max");

